import $ from 'jquery';
import i18n, { loadLocaleMessagesAsync } from "@/i18n";
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: "Gallery",
    props: {
        imageGallery: { type: Array }
    },
    data () {
      return {
        settings: {
          "centerMode": true,
          "centerPadding": "100px",
          "infinite": true,
          "slidesToShow": 2,
          "arrows": true,
          "speed": 500,
          "responsive": [{
            "breakpoint": 576,
            "settings": {
              "slidesToShow": 1,
              "dots": true,
              "centerMode": false,
              "arrows": false
            }
          }]
        }
      
      }
    },
    computed: {

    },
    components: {
      VueSlickCarousel
    }

};